import { PlayerBaseWidget } from './PlayerBaseWidget.js';

// widgets/player/VSPlayerWidget.ts
// Тонкое расширение под VS. Без новых фич.
class VSPlayerWidget extends PlayerBaseWidget {
    /** Ключевой класс для поиска виджета */
    static _cssKey() {
        return 'im-vs-player';
    }
    _create(options) {
        super._create(options);
    }
    /** Определяем команду сохранения и дергаем gateway */
    _onSaveTcRequested() {
        const i = this.getIn(), o = this.getOut(), img = this.getImg();
        const noSound = !!this.element.querySelector('.img-container .scene-nosound')?.checked;
        // решаем, изменённый или новый — по наличию uiType/editMode (как в легаси)
        const uiType = this.element.closest('.im-view')?.querySelector('[data-key="uiType"]');
        const isEdit = uiType?.value === 'FootageData';
        if (isEdit) {
            this.saveChangedFootage({
                timeIn: i, timeOut: o, titleImgTime: img, noSound
            });
        }
        else {
            // для new нужен duration
            this.saveNewFootage({
                timeIn: i, timeOut: o, titleImgTime: img, noSound,
                duration: this.mediaEl.duration || (o - i) || 0,
                uiType: this.uiType,
                ui: this.ui
            });
        }
        // как в легаси — кнопку можно «погасить»
        this.element.querySelector('.bt-save-tc')?.classList.add('off');
    }
    _onDestroy() {
        super._onDestroy();
    }
}
VSPlayerWidget._alias = "VSPlayer";

export { VSPlayerWidget };
